module.exports = __webpack_public_path__ + "static/media/shop_beach_1.a53e3391.svg";